<template>
  <a-result status='500' :title='code' :sub-title='msg'>
    <template #extra>
      <a-button type="primary" @click="backHome">Back Home</a-button>
    </template>
  </a-result>
</template>

<script>
import { useRoute,useRouter } from 'vue-router'
export default {
  name: 'ErrorPage',
  setup() {
    let route = useRoute()
    let router = useRouter()

    const code =  route.query.code;
    const msg = route.query.msg;

    const backHome=()=>{
      router.push('login');
    }

    return {
      backHome,
      code,
      msg
    };
  }
}

</script>